import { bindActionCreators } from "@reduxjs/toolkit";
import { connect } from "react-redux";

import { getRedeemableAmountV2 } from "@app/modules/checkout/selectors/get-redeemable-amount";
import { getCartTotal } from "@app/modules/checkout/store/v2/selectors/get-cart-total";
import {
  getRedeemedAmount,
  hasRedeemed
} from "@app/modules/checkout/store/v2/selectors/get-redeemed-amount";
import { getCart } from "@app/modules/checkout/store/v2/selectors/state-accessors";
import {
  redeemCredits,
  unredeemCredits
} from "@app/modules/checkout/store/v2/thunks/loyalty-rewards";
import type { CheckoutReduxStateV2 } from "@app/types/checkout-v2-types";

import type { Dispatch } from "@reduxjs/toolkit";
import type { ConnectedProps } from "react-redux";

import { RedeemCreditsFactory } from "./redeem-credits-factory";

const mapStateToProps = () => (state: CheckoutReduxStateV2) => {
  const cart = getCart(state);
  const has_redeemed = hasRedeemed(state);
  const redeemed_amount = getRedeemedAmount(state);

  return {
    ...getRedeemableAmountV2(state),
    cart_id: cart.id,
    cart_total: getCartTotal(state),
    has_redeemed: has_redeemed,
    redeemed_amount: redeemed_amount
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators(
    {
      redeemCredits,
      unredeemCredits
    },
    dispatch
  );
};

const connector = connect(mapStateToProps, mapDispatchToProps);
export type ConnectorProps = ConnectedProps<typeof connector>;

export const RedeemCredits = connector(RedeemCreditsFactory);
